import { useCallback } from 'react'
import { PRIMARY_KEY_TO_PATH } from '@/config/navigation/primaryNav'
import { SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import { DEFAULT_SETTINGS_SECTION_ID } from '@/data/settingsNavData'
import { useSettingsModal } from '@/components/Settings/SettingsModal/SettingsModalContext'
import PATHS, { buildHomeThreadPath } from '@/routes/paths'

export function useAppShellNavHandlers({ location, navigate, setSelectedThreadId, setHomeView }) {
  const { openSettings } = useSettingsModal()

  const handlePrimaryNavChange = useCallback(
    (key) => {
      if (key === 'settings') {
        openSettings(DEFAULT_SETTINGS_SECTION_ID)
        return
      }
      const nextPath = PRIMARY_KEY_TO_PATH[key]
      if (nextPath && nextPath !== location.pathname) navigate(nextPath)
      setSelectedThreadId(null)
      setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
    },
    [location.pathname, navigate, openSettings, setSelectedThreadId, setHomeView],
  )

  const handleSecondaryThreadSelect = useCallback(
    (thread) => {
      setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
      setSelectedThreadId(thread.id)
      navigate(buildHomeThreadPath(thread.id))
    },
    [navigate, setHomeView, setSelectedThreadId],
  )

  const handleSecondaryNewChat = useCallback(() => {
    setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
    setSelectedThreadId(null)
    navigate(PATHS.HOME)
  }, [navigate, setHomeView, setSelectedThreadId])

  return { handlePrimaryNavChange, handleSecondaryThreadSelect, handleSecondaryNewChat }
}
